import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { File } from 'src/app/core/services/clubs/club.model';

@Component({
  selector: 'app-club-media-files',
  templateUrl: './club-media-files.component.html',
  styleUrls: ['./club-media-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClubMediaFilesComponent {
  private static _AMOUNT_OF_FILES_IN_SECTION = 20;

  private _isLoadingMore$ = new BehaviorSubject(0);

  @Input() files: File[];
  @Input() canAddFile: boolean;

  @Output() selectFile = new EventEmitter<File>();
  @Output() removeFile = new EventEmitter<number>();

  get sections() {
    const amountOfSections = Math.ceil(
      this.files.length / ClubMediaFilesComponent._AMOUNT_OF_FILES_IN_SECTION
    );

    return Array.from(Array(amountOfSections).keys());
  }

  get isLoadingMore() {
    return this._isLoadingMore$.value > 0;
  }

  onFileChanged(files: File[]) {
    const [file] = files;
    if (!file) {
      return;
    }

    this.selectFile.emit(file);
  }

  onRemove(id: number) {
    this.removeFile.emit(id);
  }

  onStartLoadingFilesSection() {
    this._isLoadingMore$.next(this._isLoadingMore$.value + 1);
  }

  onLoadedFilesSection() {
    this._isLoadingMore$.next(this._isLoadingMore$.value - 1);
  }
}
